export const defaultLocale = "ko";

// Languages with manual translation files
export const manualTranslationLocales = ["en", "ko"];

// Check if a locale has manual translations
export function hasManualTranslations(locale) {
    return manualTranslationLocales.includes(locale);
}
